// app.routes.ts
import { Routes } from "@angular/router";
import { editorGuard } from "@app/core/guards/editor.guard";
import { authGuard } from "./core/guards/authGuard";

export const routes: Routes = [
  {
    path: "login",
    loadComponent: () =>
      import("./features/login/login.component").then(
        (m) => m.LoginComponent
      ),
      data: { showSidebar: false, showHeader: false },
  },
  // Route used by the SSO portal callback to return the token
  {
    path: "index.php/unauth/login_sso_callback",
    loadComponent: () =>
      import("./features/login/login.component").then(
        (m) => m.LoginComponent
      ),
      data: { showSidebar: false, showHeader: false },
  },
  {
    path: "",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./features/data-dictionary/data-dictionary-view/data-dictionary-view.component")
        .then((m) => m.DataDictionaryViewComponent),
    data: { showSidebar: true },
  },
  {
    path: "dictionary/:id",
    canActivate: [authGuard],
    loadComponent: () =>
      import("./features/data-dictionary/data-dictionary-detail/data-dictionary-detail.component")
        .then((m) => m.DataDictionaryDetailComponent),
    data: { showSidebar: true },
  },
  {
    path: "master-tables",
    canActivate: [authGuard, editorGuard],
    loadComponent: () =>
      import("./features/tablas-maestras/tablas-maestras.component")
        .then((m) => m.TablasMaestrasComponent),
    data: { showSidebar: false },
  },
  {
    path: "tablas-maestras",
    redirectTo: "master-tables",
    pathMatch: "full",
  },
  {
    path: "logs",
    canActivate: [authGuard, editorGuard],
    loadComponent: () =>
      import("./features/logs/logs.component").then((m) => m.LogsComponent),
    data: { showSidebar: false },
  },
  {
    path: 'unauthorized',
    loadComponent: () =>
      import("./features/unauthorized/unauthorized.component").then(
        (m) => m.UnauthorizedComponent
      ),
    data: { showSidebar: false, showHeader: false },
  },
  {
    path: "**",
    redirectTo: "",
  },
];